const getSiteUrlForCategory = (url: string) => {
    const splitArray = url.split("/")
    const shopIndex = splitArray.indexOf("shop")
    const brandsIndex = splitArray.indexOf("brands")
    const promotionsIndex = splitArray.indexOf("promotions")

    if (shopIndex !== -1) {
        splitArray.splice(shopIndex, splitArray.length - shopIndex)
    }
    if (brandsIndex !== -1) {
        splitArray.splice(brandsIndex, splitArray.length - brandsIndex)
    }
    if (promotionsIndex !== -1) {
        splitArray.splice(promotionsIndex, splitArray.length - promotionsIndex)
    }

    const siteUrlForCategory = splitArray.join("/")
    return siteUrlForCategory
}

export default getSiteUrlForCategory
